import type { z } from "zod";

export const searchParam = <T extends z.ZodType>(schema: T) => schema.optional().catch(undefined);
